import React from 'react';

const Root = () => {
  return <div id="RootPage">Unison Admin Dashboard</div>;
};

export default Root;
